import {
	SET_FORM_STATE,
	GET_UTRANCELLS_LAST_UPDATE,
	GET_UTRAN_SITES,
	GET_CPICH_VALIDATION_TABLE
} from '../actions/CpichValidationActions';

const initialState = {
	formState: { sites: [] },
	utranCellsLastUpdate: '',
	utranSites: [],
	cpichValidationTableData: []
};

const cpichValidationReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_UTRANCELLS_LAST_UPDATE: {
						return {
							...state,
							utranCellsLastUpdate: action.utranCellsLastUpdate
						};
					}
					case GET_UTRAN_SITES: {
						return {
							...state,
							utranSites: action.utranSites
						};
					}
					case GET_CPICH_VALIDATION_TABLE: {
						return {
							...state,
							cpichValidationTableData: action.cpichValidationTableData
						};
					}
					default: {
						return state;
					}
	}
};

export default cpichValidationReducer;
